import Button from './button';
import CancelButton from './cancel-button';
import ContentContainer from './content-container';
import ContentTitle from './content-title';
import DeleteButton from './delete-button';
import FormBlock from './form-block';
import FormColorInput from './form-color-input';
import FormLabel from './form-label';
import FormNumberInput from './form-number-input';
import FormSelect from './form-select';
import FormSlider from './form-slider';
import FormSubmitButton from './form-submit-button';
import FormTextInput from './form-text-input';

export {
  Button,
  CancelButton,
  ContentContainer,
  ContentTitle,
  DeleteButton,
  FormBlock,
  FormColorInput,
  FormLabel,
  FormNumberInput,
  FormSelect,
  FormSlider,
  FormSubmitButton,
  FormTextInput
};

export default {
  Button,
  CancelButton,
  ContentContainer,
  ContentTitle,
  DeleteButton,
  FormBlock,
  FormColorInput,
  FormLabel,
  FormNumberInput,
  FormSelect,
  FormSlider,
  FormSubmitButton,
  FormTextInput
};
